import { Buffer } from 'buffer';

import mime from 'mime';
import saveAs from 'file-saver';

import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import { FilterReportData } from '../../../spd/containers/RegistersView/Filter';

export interface ReportExcelContextInterface {
  reportCompanySummary: (
    filename: string,
    filter: FilterReportData,
  ) => Promise<void>;
  reportBillingSummary: (
    filename: string,
    filter: FilterReportData,
  ) => Promise<void>;
  downloadReportJudgments: (
    filename: string,
    filterText?: string,
    psychologistId?: string,
    companyId?: string,
    registerId?: string,
    healthcareFacilityId?: string,
    dateFrom?: Date,
    dateTo?: Date,
    onlyMonthlySettlement?: string,
    withHealthcareFacility?: boolean,
    withRegister?: boolean,
  ) => Promise<Blob>;
  reportSalesInvoices: (
    filename: string,
    filter: FilterReportData,
  ) => Promise<void>;
}

export const ReportExcelContext = (api: DefaultApi) => {
  return {
    reportCompanySummary: async (
      filename: string,
      filter: FilterReportData,
    ) => {
      return await api
        .reportExcelControllerReportCompanySummary({ ...filter })
        .then(async fileContent => {
          const blob = new Blob([Buffer.from(fileContent as ArrayBuffer)], {
            type: mime.getType(filename) || undefined,
          });
          await saveAs(blob, filename);
        });
    },

    downloadReportJudgments: async (
      filename: string,
      filterText?: string,
      psychologistId?: string,
      companyId?: string,
      registerId?: string,
      healthcareFacilityId?: string,
      dateFrom?: Date,
      dateTo?: Date,
      onlyMonthlySettlement?: string,
      withHealthcareFacility?: boolean,
      withRegister?: boolean,
    ) => {
      return await api.reportExcelControllerDownloadReportJudgments(
        filterText || '',
        psychologistId,
        companyId,
        registerId,
        healthcareFacilityId,
        dateFrom,
        dateTo,
        onlyMonthlySettlement,
        withHealthcareFacility,
        withRegister,
      );
    },

    reportBillingSummary: async (
      filename: string,
      filter: FilterReportData,
    ) => {
      return await api
        .reportExcelControllerReportBillingSummary({ ...filter })
        .then(async fileContent => {
          const blob = new Blob([Buffer.from(fileContent as ArrayBuffer)], {
            type: mime.getType(filename) || undefined,
          });
          await saveAs(blob, filename);
        });
    },

    reportSalesInvoices: async (filename: string, filter: FilterReportData) => {
      return await api
        .reportExcelControllerReportSalesInvoices({ ...filter })
        .then(async fileContent => {
          const blob = new Blob([Buffer.from(fileContent as ArrayBuffer)], {
            type: mime.getType(filename) || undefined,
          });
          await saveAs(blob, filename);
        });
    },
  };
};
